<template>
  <div class="container">
    <div class="wrapper">
      <div class="heading">
        <h1>Request a Quote</h1>
        <p>Let us know what you need.</p>
        <p>We will get back to you.</p>
      </div>
      <form class="form" action="https://formspree.io/f/xrgjlwpn" method="POST">
        <!-- add FORMSPREE email address here.-->
        <div class="form-group">
          <label for="name">Name</label>
          <input type="text" name="name" id="name" required />
        </div>
        <div class="form-group">
          <label for="email">Email</label>
          <input type="email" name="email" id="email" required />
        </div>
        <div class="form-group">
          <label for="message">Message ( {{ count }} / {{ maxlength }} )</label>
          <textarea
            name="message"
            id="message"
            v-model="message"
            :maxlength="maxlength"
            required
          ></textarea>
        </div>
        <div class="submit">
          <button type="submit">Send</button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { computed, ref } from "vue";

export default {
  setup() {
    let maxlength = ref(180);
    let message = ref("");
    let count = computed(() => {
      return message.value.length;
    });
    return {
      maxlength,
      message,
      count,
    };
  },
};
</script>

<style scoped>
.container {
  min-width: 100vw;
  max-width: 1300px;
  min-height: 100%;
  margin-top: 2rem;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.15s ease-in-out;
}
.wrapper {
  border: 1px solid rgba(0, 0, 0, 0.25);
  margin: 1.5rem auto;
  width: 100%;
  max-width: 600px;
  min-width: 220px;
  padding: 0 1rem;
  background-color: rgba(0, 0, 0, 0.25);
  text-align: left;
  padding: 0.5rem;
  border-radius: 15px;
  box-shadow: 3px 3px 5px 3px rgba(0, 0, 0, 0.25);
}

.heading {
  text-align: center;
  font-size: 0.75rem;
  margin-bottom: 1.5rem;
  line-height: 1.5;
  max-width: 100%;
  transition: all 0.25s ease-in-out;
}

.heading p {
  color: #3a3232;
}

.form {
  width: 100%;
}
.form-group {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  margin-bottom: 1rem;
  transition: all 0.25s ease-in-out;
}

.form-group label {
  font-size: 0.75rem;
  outline: none;
  margin-bottom: 0.25rem;
  transition: all 0.25s ease-in-out;
}
.form-group input {
  font-size: 1.15rem;
  width: 100%;
  padding: 10px;
  height: 2.5rem;
  border-radius: 10px;
  box-shadow: 3px 3px 5px 3px rgba(0, 0, 0, 0.25);
  outline: none;
  transition: all 0.25s ease-in-out;
}

.form-group textarea {
  font-size: 1.15rem;
  padding: 10px;
  min-height: 100px;
  border-radius: 10px;
  box-shadow: 3px 3px 5px 3px rgba(0, 0, 0, 0.25);
  min-width: 100%;
  outline: none;
  transition: all 0.25s ease-in-out;
}
.submit {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 0.5rem;
}

.submit button {
  font-family: boombox, Helvetica, Arial, sans-serif;
  outline: none;
  display: inline-block;
  margin-top: 0.5rem;
  margin-bottom: 1rem;
  max-width: 300px;
  min-width: 200px;
  color: #fff;
  padding: 12px 25px;
  border-radius: 22px;
  font-size: 0.8rem;
  text-transform: uppercase;
  box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset,
    rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset,
    rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px,
    rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px,
    rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;
  background-color: #fa4349;
  transition: all 0.25s ease-in-out;
}

.submit button:hover {
  transform: scale(1.05);
}

/*=========================================== MEDIA=========================================================== */

@media screen and (min-width: 500px) {
  .heading {
    text-align: left;
    font-size: 0.85rem;
  }
  .wrapper {
    padding: 1rem;
  }
  .container {
    height: 100%;
  }
  .submit button {
    font-size: 0.9rem;
  }

  .form-group label {
    font-size: 0.9rem;
  }
}
@media screen and (min-width: 768px) {
}
</style>